import { createFileRoute } from '@tanstack/react-router';
import { ProductDetails } from '@/pages/ProductDetails';
import { PageType } from '@/types/agent';

export interface ProductSearchPageType {
  pageType: PageType | undefined;
  agentId: string | undefined;
  access_token: string | undefined;
  state: string | undefined;
}

export const Route = createFileRoute('/_auth/compagnies/$id/products/$productId')({
  component: ProductDetails,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      pageType: search.pageType,
      agentId: search.agentId,
      access_token: search.access_token,
      state: search.state,
    } as ProductSearchPageType;
  },
});
